import Box from '@mui/material/Box';
import { PaperExpandable } from '../../../components/paper-expandable';

export function Announcements() {
  return (
    <PaperExpandable title="Announcements" count={0}>
      <Box
        sx={{
          p: 4,
          textAlign: 'center',
          fontFamily: 'Roboto Mono',
          color: '#9b9b9b',
        }}
      >
        No announcements to be made at this time
      </Box>
    </PaperExpandable>
  );
}
